import http from 'axios'

export default {
  getAnneeRecolteEnCours: () => {
    return http.get(`/web/v1/recoltes/annee`)
  },
  getAllCategoriesContrats: () => {
    return http.get(`/web/v1/contrats/categories`)
  },
  getAllTypeCultures: () => {
    return http.get(`/web/v1/type-culture`)
  },
  getAllGrainesRs3: () => {
    return http.get(`/web/v1/graines/rs3`)
  },
  getAvisCampagne: () => {
    return http.get('/web/v1/campagne')
  }
}
